<template>
  <div>
    <cms-form @submit="updatePost"
              :post="currentCms"
              :loading="loading">
    </cms-form>
  </div>
</template>
<script>
  import CmsForm from './CmsForm'
  import CMSService from 'src/services/CMSService'
  export default {
    name: 'cms-edit',
    components: {
      CmsForm
    },
    data () {
      return {
        loading: false
      }
    },
    computed: {
      currentCms() {
        return this.$store.state.cms.currentCms
      }
    },
    methods: {
      async updatePost(post) {
        try {
          this.loading = true
          await CMSService.update(post.id, post)
          this.$router.push('/content/cms')
        } catch (e) {
          console.warn(e)
        }
        this.loading = false
      }
    }
  }
</script>
<style>
</style>
